export const canEditOfflineSupplierProduct = (
  companyId?: string | number | null,
  supplierCompanyId?: string | number | null
): boolean =>
  !!companyId && !!supplierCompanyId && Number(companyId) === Number(supplierCompanyId);
